import script from "./ChurchSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ChurchSettings.vue?vue&type=script&setup=true&lang=js"

import "./ChurchSettings.vue?vue&type=style&index=0&id=47414ebe&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47414ebe"]])

export default __exports__